











































































































import {Component, Vue} from 'vue-property-decorator';

import LoginLayout from '@/layouts/LoginLayout.vue';
import {login} from '@/repositories/api/SecurityApiRepository';
import Alert from '@/models/Alert';
import {AlertTypes} from '@/models/AlertTypes';

@Component({
  components: {
    LoginLayout,
  },
})
export default class LoginView extends Vue {
  valid = false;
  alert: { show: boolean, message: string, type: string } = {show: false, message: '', type: ''};
  email = '';
  password = '';
  passwordLength = 8;
  loading = false;

  emailRules = [
    (value: string) => !!value || 'Un e-mail est requis',
    (value: string) => /.+@.+/.test(value) || 'L\'email doit être valide',
  ];

  passwordRules = [
    (value: string) => !!value || 'Mot de passe requis',
    (value: string) => value.length >= this.passwordLength || 'Le mot de passe doit contenir au moins de 8 caractères',
  ];

  async login() {
    this.loading = true;
    let response = {};
    let success = true;

    try {
      response = await login({username: this.email, password: this.password});
    } catch (e) {
      success = false;
      this.alert = new Alert('Identifiant ou mot de passe incorrect', AlertTypes.Error, true);
    }

    this.loading = false;

    if (success && response) {
      // await this.$router.push({name: 'authentication'})
      this.alert = new Alert('Votre clé d\'authentification, vous a été transmis par mail', AlertTypes.Success, true);
    }

  }
}
